import { OrganizationSelectors } from "@core/organization";
import { createSelector } from "reselect";
import _ from "underscore";
import { PrivilegesListSelector } from "../../privileges/selectors/PrivilegesListSelectors.js";
import { UserPrivilegesValidator } from "../utils/UserPrivilegesValidator.js";
var getPrivilegesValidator = createSelector(PrivilegesListSelector.getUserPrivilegesList, OrganizationSelectors.getOrganization, function(userPrivileges) {
    return new UserPrivilegesValidator(userPrivileges);
});
var getUser = function(state) {
    return state.user;
};
var getUserFirstName = createSelector(getUser, function(user) {
    return user === null || user === void 0 ? void 0 : user.firstName;
});
var getUserLastName = createSelector(getUser, function(user) {
    return user === null || user === void 0 ? void 0 : user.lastName;
});
var getUserEmail = createSelector(getUser, function(user) {
    return user === null || user === void 0 ? void 0 : user.email;
});
var ref;
var getUsername = createSelector(getUser, function(user) {
    return (ref = user === null || user === void 0 ? void 0 : user.username) !== null && ref !== void 0 ? ref : "";
});
var ref1, ref2;
var getUserDisplayName = createSelector(getUser, getUsername, function(user, username) {
    return (ref2 = (ref1 = user === null || user === void 0 ? void 0 : user.displayName) !== null && ref1 !== void 0 ? ref1 : user === null || user === void 0 ? void 0 : user.name) !== null && ref2 !== void 0 ? ref2 : username;
});
var ref3;
var getUserRealms = createSelector(getUser, function(user) {
    return _.chain((ref3 = user === null || user === void 0 ? void 0 : user.realms) !== null && ref3 !== void 0 ? ref3 : []).filter({
        member: true
    }).map("realm").value();
});
var isRelevanceInspectorAvailable = createSelector(getPrivilegesValidator, function(validator) {
    return validator.canExecuteQuery && validator.canReplayAnyQuery;
});
var ref4;
var getAdditionalInformation = createSelector(getUser, function(user) {
    return (ref4 = user === null || user === void 0 ? void 0 : user.additionalInformation) !== null && ref4 !== void 0 ? ref4 : {};
});
var canViewAllContent = createSelector(getPrivilegesValidator, function(user) {
    return user.canViewAllContent;
});
export var UserSelectors = {
    getPrivilegesValidator: getPrivilegesValidator,
    getUser: getUser,
    getUsername: getUsername,
    getUserDisplayName: getUserDisplayName,
    getUserRealms: getUserRealms,
    getAdditionalInformation: getAdditionalInformation,
    getUserFirstName: getUserFirstName,
    getUserLastName: getUserLastName,
    getUserEmail: getUserEmail,
    isRelevanceInspectorAvailable: isRelevanceInspectorAvailable,
    canViewAllContent: canViewAllContent
};

//# sourceMappingURL=UserSelectors.js.map